import React from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Input } from "reactstrap"

const GlobalFilter = ({ globalFilter, setGlobalFilter, count }) => {
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(v => {
    setGlobalFilter(v || undefined)
  }, 200)
  return (
    <Col sm={4}>
      <div className="search-box me-2 mb-2 d-inline-block">
        <div className="position-relative">
          <Input
            type="text"
            className="form-control"
            placeholder={`${count} records...`}
            value={value || ""}
            onChange={e => {
              setValue(e.target.value)
              onChange(e.target.value)
            }}
          />
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </div>
    </Col>
  )
}

const ReportTable = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data: data || [],
      initialState: { pageSize: 10, pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  return (
    <React.Fragment>
      <Row className="mb-2">
        <GlobalFilter
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          count={preGlobalFilteredRows.length}
        />
      </Row>
      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()}>
          <thead className="table-light table-center">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.id} {...column.getHeaderProps()}>
                    <div {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {column.isSorted ? (
                        <i
                          className={
                            column.isSortedDesc
                              ? " bx bx-sort-down"
                              : " bx bx-sort-up"
                          }
                        ></i>
                      ) : (
                        ""
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map(row => {
                prepareRow(row)
                return (
                  <tr key={row.id} {...row.getRowProps()}>
                    {row.cells.map(cell => (
                      <td
                        key={cell.column.id}
                        {...cell.getCellProps()}
                        data-label={cell?.column?.Header}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                )
              })
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="react-bs-table-no-data text-center"
                >
                  Sorry, There are no data to display
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {page.length > 0 && (
        <Row className="justify-content-end align-items-center">
          <Col className="col-md-auto p-2">
            <select
              className="form-select p-1"
              value={pageSize}
              onChange={e => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map(size => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </Col>
          <Col className="col-md-auto">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
          </Col>
          <Col className="col-md-auto">
            <div className="d-flex gap-1">
              <Button
                color="primary"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </Button>
              <Button
                color="primary"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </React.Fragment>
  )
}

ReportTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
}

export default ReportTable
